import React, { useEffect, useState, useCallback } from 'react';
import { Grid, TextField, Slider } from '@mui/material';
import { debounce } from 'lodash';

function TextOptionComponent(props) {
  const { member, isDisabled, startData, onChange } = props;
  const [value, setValue] = useState(member.value);
  const [valueDescription, setValueDescription] = useState(
    member.valueDescription
  );

  const debouncedSearch = useCallback(
    debounce(e => {
      onChange(e);
    }, 1000),
    [startData.configState]
  );

  useEffect(() => {
    setValue(member.value);
  }, [member.value, startData]);

  useEffect(() => {
    setValueDescription(member.valueDescription);
  }, [member.valueDescription, startData]);

  const isSlider = () => {
    if (member.properties.ph_use_slider) {
      return false;
    }
    return member.domain.min;
  };

  const isSliderControl = () => {
    return member.properties.ph_slider == 'yes' || !member.properties.ph_slider;
  };

  const handleSliderChange = e => {
    setValue(e.target.value);
    debouncedSearch(e);
  };

  const onTextChange = event => {
    setValue(event.target.value);
  };

  const onTextChangeValueDescription = event => {
    setValueDescription(event.target.value);
  };

  const onBlur = e => {
    if (e.target.value !== member.value) {
      onChange(e);
    }
  };

  const onBlurValueDescription = e => {
    if (e.target.value !== member.value) {
      onChange(e);
    }
  };

  const handleEnterKey = e => {
    if (e.key === 'Enter') {
      if (e.target.value !== member.value) {
        onChange(e);
      }
    }
  };

  const handleEnterKeyValueDescription = e => {
    if (e.key === 'Enter') {
      if (e.target.value !== member.value) {
        onChange(e);
      }
    }
  };

  return (
    <Grid container>
      {isSlider() ? (
        isSliderControl() ? (
          <>
            <Grid item xs={12}>
              <TextField
                type="number"
                className="w-100 textbox-number"
                value={value}
                disabled={isDisabled}
                onChange={e => onTextChange(e)}
                onKeyUp={e => handleEnterKey(e)}
                onBlur={e => onBlur(e)}
                InputProps={{
                  inputProps: {
                    min: +member.domain.min,
                    max: +member.domain.max
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} className="range-padding">
              <span>{member.domain.min}</span>
            </Grid>
            <Grid item xs={6} className="align-right range-padding">
              <span>{member.domain.max}</span>
            </Grid>
            <Grid item xs={12} className="slider-padding">
              <Slider
                size="medium"
                value={+value}
                aria-label="Default"
                valueLabelDisplay="auto"
                min={+member.domain.min}
                max={+member.domain.max}
                disabled={isDisabled}
                onChange={e => handleSliderChange(e)}
                step={1}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <TextField
                type="number"
                className="w-100 textbox-number"
                value={valueDescription ? valueDescription : ''}
                disabled={isDisabled}
                onChange={e => onTextChangeValueDescription(e)}
                onBlur={e => onBlurValueDescription(e)}
                onKeyUp={e => handleEnterKeyValueDescription(e)}
                InputProps={{
                  inputProps: {
                    min: +member.domain.min,
                    max: +member.domain.max
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} className="range-padding">
              <span>{member.domain.min}</span>
            </Grid>
            <Grid item xs={6} className="align-right range-padding">
              <span>{member.domain.max}</span>
            </Grid>
          </>
        )
      ) : (
        <TextField
          type="text"
          className="w-100 textbox-number"
          value={valueDescription ? valueDescription : ''}
          disabled={isDisabled}
          onChange={e => onTextChangeValueDescription(e)}
          onBlur={e => onBlurValueDescription(e)}
          onKeyUp={e => handleEnterKeyValueDescription(e)}
        />
      )}
    </Grid>
  );
}
export default TextOptionComponent;
